import { Component } from '@angular/core';
import { LocalDataSource } from 'ng2-smart-table';
import { Registry } from '@/registry.service';
import { CommissionsSignalmanService } from '@services/data-source-tables/commissions-signalman.service';
import { CommissionsSignalmanSettings } from '@/table-settings/tables/commissions-signalman-settings';

@Component({
  selector: 'app-commission-signalman',
  templateUrl: './commission-signalman.component.html',
  styleUrls: ['./commission-signalman.component.scss'],
})
export class CommissionSignalmanComponent {
  source: LocalDataSource;
  settings = CommissionsSignalmanSettings.gridSettings();

  constructor(private commissionsSignalmanService: CommissionsSignalmanService) {
    this.source = new LocalDataSource([]);

    Registry.getInstance().set('CommissionSignalmanComponent', this);

    this.loadCommissions();
  }

  loadCommissions() {
    this.commissionsSignalmanService.getAll().subscribe((brands) => {
      this.source.load(brands);
    });
  }
}
